import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_DYNAMIC_PROCESS: MijnRoute = {
    path: ':webcomponent',
    navigationEvent: 'toZelfRegelenDynamicProcess',
    regex: /^\/zelf-regelen\/[^/]+$/
};
